import { IonItem, useIonLoading } from '@ionic/react';
import { Trans } from '@lingui/macro';
import React, { useEffect, useRef } from 'react';

import { LoadableValue } from '../../types/Generic';

type LoadableContentProps = {
    value: LoadableValue;
    ignoreError?: boolean;
    children: React.ReactNode;
};

const LoadableContent: React.FunctionComponent<LoadableContentProps> = ({
    value,
    ignoreError = false,
    children,
}) => {
    const [present, dismiss] = useIonLoading();
    const timer = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        timer.current && clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            if (value.state === 'loading') {
                present({
                    spinner: 'circular',
                    animated: true,
                });
            } else {
                dismiss();
            }
        }, 10);

        if (value.state === 'loading') {
            present({
                spinner: 'circular',
                animated: true,
            });
        } else {
            dismiss();
        }

        return () => {
            timer.current && clearTimeout(timer.current);
            dismiss();
        };
    }, [dismiss, present, value.state]);

    if (!ignoreError && value.state === 'hasError') {
        return (
            <IonItem lines="none">
                <h4>
                    <Trans>Oops! Something went wrong!</Trans>
                </h4>
            </IonItem>
        );
    }

    if (value.state === 'loading') {
        return <></>;
    }

    return <>{children}</>;
};

export default LoadableContent;
